/* eslint-disable */
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Print from 'vue-print-nb'
import App from './App.vue'
import router from './router'

// 1. 基础配置
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Print)

// 2. Axios 默认配置
axios.defaults.baseURL = '/'
axios.defaults.timeout = 30000
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'

// —— 新增两行：启用 CSRF 支持 ——
// 自动从名为 'csrftoken' 的 Cookie 读取值，并设置到 X-CSRFToken 头
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

Vue.prototype.$http = axios

// 3. 全局 Axios 响应拦截器：遇到 401 就自动跳登录页
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.path !== '/login') {
        router.push('/login').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
      }
    }
    return Promise.reject(error)
  }
)

// 4. 路由守卫（这里不做改动）
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register') {
    next()
  } else {
    next()
  }
})

// 5. 全局重写 router.push，屏蔽 NavigationDuplicated 异常
const originalPush = router.push
router.push = function(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
